import React, { useState } from 'react'
import Popover from '../Popover'
import './filterPanel.scss'
import FilterIcon from '../../assets/svgs/table-filter.svg'
import CheckBox from '../CheckBox'
import ButtonBase from '../ButtonBase'

export const FilterPanel = ({ column: { filterState, filterOptions, updateColumnFilter }, setIsOpen }) => {
  const [internalState, setInternalState] = useState(filterState?.values || {})
  return <div className={'Suc-filter-panel'}>
    <div className={'Suc-filter-content'}>
      {(filterOptions && filterOptions.length > 0) && filterOptions.map(({ value, label }) => {
        return <CheckBox key={value} name={value} checked={internalState[value] || false}
                         onChange={() => setInternalState({ ...internalState, [value]: !internalState[value] })}>
          <span>{label}</span>
        </CheckBox>
      })}
    </div>
    <div className={'Suc-buttons-row'}>
      <ButtonBase onClick={() => {
        setInternalState({})
        updateColumnFilter({})
        setIsOpen(false)
      }}>Clear
      </ButtonBase>
      <ButtonBase onClick={() => {
        updateColumnFilter(internalState)
        setIsOpen(false)
      }}>Apply
      </ButtonBase>
    </div>
  </div>
}

export const FilterButton = ({ column }) => {
  const [isOpen,setIsOpen] = useState(false)

  return <Popover
    visible={isOpen}
    appendToBody={true}
    container={<ButtonBase onClick={()=>setIsOpen(prev=>!prev)}><FilterIcon/></ButtonBase>}
    containerClass={`Suc-internal-filter-trigger-button ${isOpen ? "Suc-active" : ""}`}
  ><FilterPanel column={column} setIsOpen={setIsOpen}/></Popover>
}
